import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {forkJoin, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { HMOLicence } from '../models/hmo-licence/hmo-licence';
import { HMOLicencePost } from '../models/hmo-licence/hmo-licence-post';
import { HMOLicenceOverview } from '../models/hmo-licence/hmo-licence-overview';
import { FileService } from "./file.service";
import { OwnerHMOLicenceOverview } from '../models/hmo-licence/owner-hmo-licence-overview';
import {PropertyServicesSummary} from "../models/property-services/property-services-summary.interface";
import {mergeMap, tap} from "rxjs/operators";
import {GasSafetyCertificatePost} from "../models/gas-safety-certificate/gas-safety-certificate-post";
import {GasSafetyCertificate} from "../models/gas-safety-certificate/gas-safety-certificate";
import {BoilerService} from "../models/boiler-service/boiler-service";
import {ElectricalInstallationConditionReport} from "../models/electrical-installation-condition-report/electrical-installation-condition-report";

@Injectable()
export class HMOLicenceService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getOverview(propertyReference: string): Observable<HMOLicenceOverview> {
        return this.http.get<HMOLicenceOverview>(`${this.configService.baseUrl}/manage/property/${propertyReference}/hmo-licences/overview`);
    }

    getList(propertyReference: string): Observable<HMOLicence[]> {
        return this.http.get<HMOLicence[]>(`${this.configService.baseUrl}/manage/property/${propertyReference}/hmo-licences`);
    }

    getOwnerOverview(propertyReference: string): Observable<OwnerHMOLicenceOverview> {
        return this.http.get<OwnerHMOLicenceOverview>(`${this.configService.baseUrl}/owner/property/${propertyReference}/hmo-licences/overview`);
    }

    getOwnerList(propertyReference: string): Observable<HMOLicence[]> {
        return this.http.get<HMOLicence[]>(`${this.configService.baseUrl}/owner/property/${propertyReference}/hmo-licences`);
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<HMOLicence>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/hmo-licences/${guid}`);
    }

    add(organisationReference: string, model: HMOLicencePost): Observable<HMOLicence> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<HMOLicence>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/hmo-licences`, model))
        );
    }

    remove(propertyReference: string, item: HMOLicence): Observable<boolean> {
        return this.http.delete<boolean>(`${this.configService.baseUrl}/manage/property/${propertyReference}/hmo-licences/${item.guid}`);
    }

    getOwnerHMOLicence(propertyReference: string, guid: string): Observable<HMOLicence> {
        return this.http.get<HMOLicence>(`${this.configService.baseUrl}/owner/property/${propertyReference}/hmo-licences/${guid}`);
    }

    getSummary(propertyReference: string) {
        return this.http.get<PropertyServicesSummary>(`${this.configService.baseUrl}/manage/property/${propertyReference}/hmo-licences/summary`);
    }
}
